module.exports = "/_next/static/images/1823827adcb447e1970054bbab16e2cb-hero-variant-a-mobile.jpg.webp";